import { ADDMODAL, POPMODAL } from './constants';

export const initialState = {
  modal: [],
  submodalInfo: {}
};

const modalManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDMODAL:
      if (state.modal.includes(action.modal)) return state;
      return {
        ...state,
        modal: [...state.modal, action.modal],
        submodalInfo: {
          ...state.submodalInfo,
          [action.modal]: {
            subModal: action.submodal,
            data: action.data,
            callback: action.callback
          }
        }
      };
    case POPMODAL: {
      if (!state.modal.includes(action.modal) && !Object.prototype.hasOwnProperty.call(state.submodalInfo, action.modal)) return state;
      const submodalInfo = { ...state.submodalInfo };
      delete submodalInfo[action.modal];
      return {
        ...state,
        modal: state.modal.filter((key) => key !== action.modal),
        submodalInfo
      };
    }
    default:
      return state;
  }
};

export default modalManagerReducer;
